import React from 'react';
import { User } from 'firebase/auth';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import LanguageSelector from '../components/languageSelector';
import '../styles/mainpage-styles.css';
import '../styles/team.css';

interface TeamPageProps {
    user: User | null;
}

const PLACEHOLDER_AVATAR = "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";

const TeamPage = ({ user }: TeamPageProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation("common");

    return (
        <div className="page-wrapper">
            <div className="header-frost"></div>
            <div className="header">
                <div className="header-left">
                    <button
                        className="icon-button"
                        style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'contents', color: 'inherit' }}
                        onClick={() => navigate(-1)}
                    >
                        <KeyboardBackspaceOutlinedIcon />
                    </button>
                    <div className="vertical-line"></div>
                    <p className="greeting">
                        <span className="greeting-sentence">Metaclass</span>
                        <span>{t("team.title")}</span>
                    </p>
                </div>
            </div>

            <div className="team-page">

                <section className="team-section">
                    <h2 className="team-section-title">{t("team.developers")}</h2>
                    <div className="team-cards">
                        <div className="team-card">
                            <img className="team-avatar" src={PLACEHOLDER_AVATAR} alt="Çağan Efe Çalıdağ" />
                            <div className="team-card-info">
                                <a className="team-name team-name-glow" href="https://cagancalidag.com" target="_blank" rel="noreferrer">
                                    Çağan Efe Çalıdağ
                                </a>
                                <span className="team-role">{t("team.role-developer")}</span>
                                <span className="team-quote">"{t("team.cagan-quote")}"</span>
                            </div>
                        </div>
                        <div className="team-card">
                            <img className="team-avatar" src={PLACEHOLDER_AVATAR} alt="Deniz Hönigs" />
                            <div className="team-card-info">
                                <a className="team-name team-name-glow" href="https://denizhonigs.com" target="_blank" rel="noreferrer">
                                    Deniz Hönigs
                                </a>
                                <span className="team-role">{t("team.role-developer")}</span>
                                <span className="team-quote">"{t("team.deniz-quote")}"</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="team-section">
                    <h2 className="team-section-title">{t("team.honorable")}</h2>
                    <p className="team-section-subtitle">{t("team.honorable-sub")}</p>
                    <div className="team-cards">
                        <div className="team-card team-card-secondary">
                            <img className="team-avatar team-avatar-sm" src={PLACEHOLDER_AVATAR} alt="Alper Özer" />
                            <div className="team-card-info">
                                <span className="team-name">Alper Özer</span>
                                <span className="team-role">{t("team.role-backend")}</span>
                            </div>
                        </div>
                        <div className="team-card team-card-secondary">
                            <img className="team-avatar team-avatar-sm" src={PLACEHOLDER_AVATAR} alt="Tuğrul Başar" />
                            <div className="team-card-info">
                                <span className="team-name">Tuğrul Başar</span>
                                <span className="team-role">{t("team.role-backend")}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="team-section team-thanks-section">
                    <h2 className="team-section-title">{t("team.special-thanks")}</h2>
                    <div className="team-card team-card-thanks">
                        <img className="team-avatar" src={PLACEHOLDER_AVATAR} alt="Yıldız Hamzaoğlu Yıldız" />
                        <div className="team-card-info">
                            <span className="team-name">Yıldız Hamzaoğlu Yıldız</span>
                            <span className="team-role">{t("team.role-teacher")}</span>
                            <p className="team-thanks-text">{t("team.thanks-note")}</p>
                        </div>
                    </div>
                </section>

            </div>

            <div className="footer">
                <p>©2024 <Link to="/team">Metaclass</Link></p>
                <span className="footer-links">
                    <a href="https://forms.gle/1dXApjbXShd4mSZD8" target="_blank" rel="noreferrer">{t("footer.feedback")}</a>
                    <span className="link-dot">•</span>
                    <LanguageSelector />
                </span>
            </div>
        </div>
    );
};

export default TeamPage;
